import { AbilityBuilder, createMongoAbility } from "@casl/ability";
import AclService from "../services/AclService";

/**
 * Interseção campus ∩ turma: só libera o que o usuário E a turma permitem.
 */
export function intersectAbilities(campusAbility, classAbility) {
  const { can, build } = new AbilityBuilder(createMongoAbility);
  const classRules = (classAbility && classAbility.rules) || [];

  classRules.forEach(rule => {
    if (rule.inverted) return;
    const actions = [].concat(rule.action == null ? [] : rule.action);
    const subjects = [].concat(rule.subject == null ? [] : rule.subject);

    actions.forEach(action => {
      subjects.forEach(subject => {
        if (
          action != null &&
          subject != null &&
          campusAbility &&
          campusAbility.can(action, subject)
        ) {
          can(action, subject);
        }
      });
    });
  });

  return build();
}

export const createAbility = async () => {
  const res = await AclService.getAcl();
  return createMongoAbility(res || []);
};

/**
 * Ability das ações na turma = ACL da turma ∩ ACL do campus.
 * @param {string} classId
 * @param {import('@casl/ability').MongoAbility} [campusAbility] — se omitido, busca getAcl
 */
export const createClassAbility = async (classId, campusAbility) => {
  const classRules = await AclService.getClassAcl(classId);
  const classAbility = createMongoAbility(classRules || []);
  const campus =
    campusAbility || createMongoAbility((await AclService.getAcl()) || []);
  return intersectAbilities(campus, classAbility);
};
